import { PropsWithChildren, type ComponentProps, type FormEventHandler, type ReactNode } from 'react';
import { Button } from '@startuptools/ui/Button';
import { Stack } from '@startuptools/ui/Stack';
import { Modal } from '@startuptools/ui/Modal';
import { ModalDialog } from '@startuptools/ui/ModalDialog';
import { Typography } from '@startuptools/ui/Typography';
import { Trans } from '@lingui/react';

export const PromptDialog = ({
  title,
  loading,
  onCancel,
  onSubmit,
  acceptLabel = <Trans id="Save" />,
  children,
  modalDialogProps,
}: PropsWithChildren<{
  title: ReactNode;
  acceptLabel?: ReactNode;
  loading: boolean;
  onCancel: () => void;
  onSubmit: FormEventHandler<HTMLFormElement>;
  modalDialogProps?: ComponentProps<typeof ModalDialog>;
}>) => {
  return (
    <Modal open onClose={onCancel}>
      <ModalDialog {...modalDialogProps}>
        <form onSubmit={onSubmit}>
          <Stack gap={3}>
            <Typography level="h4">{title}</Typography>
            {children}
            <Stack direction="row" flexGrow={1} gap={2} justifyContent="end">
              <Button type="button" onClick={onCancel} disabled={loading} variant="plain" color="neutral">
                <Trans id="Cancel" />
              </Button>
              <Button type="submit" loading={loading} variant="solid">
                {acceptLabel}
              </Button>
            </Stack>
          </Stack>
        </form>
      </ModalDialog>
    </Modal>
  );
};
